import { useEffect, useState } from "react";

import {
  Card,
  CardContent,
  Button,
  Container,
  Grid,
  Typography,
  Box,
  Chip,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import { api } from "../api";
import MetricCard from "../components/MetricCard";

function ObligationsPage() {
  const navigate = useNavigate();

  const [obligations, setObligations] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const response = await api.get("/obligations");

    setObligations(response.data);
  };

  return (
    <Container
      maxWidth={false}
      sx={{
        py: 5,
        px: 6,
        width: "100%",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          mb: 6,
        }}
      >
        <Typography variant="h2" fontWeight={800} gutterBottom>
          Obligations Dashboard
        </Typography>

        <Typography variant="h6" color="text.secondary">
          Upload, validate and monitor compliance evidence using AI
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center" alignItems="stretch">
        {obligations.map((item) => (
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            key={item.id}
            sx={{
              display: "flex",
            }}
          >
            <Card
              sx={{
                width: "100%",
                height: 280,
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
                background: "#fff",
                boxShadow: "0 8px 30px rgba(15,23,42,.08)",
                border: "1px solid #E2E8F0",
                transition: ".3s",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 20px 40px rgba(15,23,42,.15)",
                },
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  p: 3,
                }}
              >
                <Chip
                  label="OPEN"
                  sx={{
                    alignSelf: "flex-start",
                    mb: 2,
                    bgcolor: "#DCFCE7",
                    color: "#15803D",
                    fontWeight: 700,
                    fontSize: 12,
                  }}
                />

                <Typography
                  variant="h5"
                  fontWeight={700}
                  sx={{
                    minHeight: 50,
                    lineHeight: 1.3,
                    mb: 1,
                  }}
                >
                  {item.title}
                </Typography>

                <Typography color="text.secondary" mb={1}>
                  <strong>Department:</strong> {item.department}
                </Typography>

                <Typography color="text.secondary" mb={3}>
                  <strong>Due Date:</strong>{" "}
                  {new Date(item.due_date).toLocaleDateString()}
                </Typography>

                <Box mt="auto">
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => navigate(`/obligation/${item.id}`)}
                    sx={{
                      mt: 2,
                      borderRadius: 3,
                      textTransform: "none",
                      fontWeight: 700,
                      fontSize: 15,
                      bgcolor: "#2563EB",
                      color: "#fff",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#1D4ED8",
                        boxShadow: "0 8px 20px rgba(37,99,235,.25)",
                      },
                    }}
                  >
                    View Details
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default ObligationsPage;
